/**
 * ASTROFALL — cartridge palette.
 *
 * First vector cartridge. Pure black field, phosphor-green vector lines
 * (Asteroids/Lunar Lander cabinet heritage), yellow HUD numerals, occasional
 * magenta tint for the gravity-well event so it pops against the green field.
 *
 * Unlike every other cartridge, this one uses STROKES only — no fills.
 * `lineWidth = 1.5` + the wide-radius soft glow trick (drawing each line
 * twice, once thick + dim and once thin + bright) approximates the CRT
 * phosphor blooming the original arcade cabinets did with analog vector
 * tubes.
 */

export const FIELD_BG = '#000000';

// Phosphor green vector lines. `VECTOR_LINE` is the bright thin pass;
// `VECTOR_BLOOM` is the wider, dimmer underlay that fakes the CRT halo.
export const VECTOR_LINE = '#33ff33';
export const VECTOR_BLOOM = 'rgba(51, 255, 51, 0.35)';

// Slightly cooler tint for the ship so it reads as the player against the
// uniform-green asteroid swarm.
export const SHIP_LINE = '#7afff0';
export const SHIP_BLOOM = 'rgba(122, 255, 240, 0.35)';

// Thruster flame — warm orange so the throttle reading is unmistakable.
export const THRUSTER = '#ffb030';

// Bullets — bright yellow dot, stands out against green field and the
// (cooler) ship.
export const BULLET = '#ffea00';

// Gravity well event — magenta event marker so it visually dominates when
// active. Read as "danger" against the calm green field.
export const GRAVITY_WELL = '#ff40c0';
export const GRAVITY_WELL_BLOOM = 'rgba(255, 64, 192, 0.4)';

// HUD.
export const HUD_TEXT = '#7af3c8';
export const HUD_SCORE = '#ffea00';
export const HUD_LIVES = '#7afff0';
export const HUD_WAVE = '#33ff33';

// Effects.
export const FLASH_HIT = '#ffffff';
export const HYPERSPACE_FLASH = '#ff40c0';

/** Tokens the cabinet samples for marquee tinting while this cartridge is loaded. */
export const PALETTE_HINT: readonly string[] = [
  VECTOR_LINE,
  SHIP_LINE,
  BULLET,
  GRAVITY_WELL,
];
